module.exports = __webpack_public_path__ + "static/Logo-fa62c4b41b9ecbe18bd027f1626fb406.png";